









import { defineComponent } from "@vue/composition-api";
import CardInfo from "@/components/CardInfo";

export default defineComponent({
  name: "NoLevelsView",
  components: { CardInfo },
});
